import IframeCommunication from './IframeCommunication'

export default IframeCommunication
